import { useEffect, type CSSProperties } from "react";
import { useStore } from "../store/globalState";
import "./Toast.css";

/** CSS `border-color` cannot paint a gradient. Partner buttons often are one. */
function solidFill(value: string): string {
  const hex = value.match(
    /#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})\b/,
  );
  return hex?.[0] ?? value;
}

export interface ToastProps {
  message: string;
  duration?: number;
  type?: "success" | "error" | "info";
  onClose?: () => void;
}

export const Toast = ({
  message,
  duration = 2000,
  type = "success",
  onClose,
}: ToastProps) => {
  const { backgroundBtn, bodyCopy } = useStore().theme.whiteView;

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div
      className={`toast toast-${type}`}
      role="status"
      style={
        {
          "--toast-accent": solidFill(backgroundBtn),
          "--toast-ink": solidFill(bodyCopy),
        } as CSSProperties
      }
    >
      {type === "success" && <span className="toast-icon">✓</span>}
      {type === "error" && <span className="toast-icon">✕</span>}
      <span className="toast-message">{message}</span>
    </div>
  );
};
